import type { ChangeEvent } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LanguageIcon from '@mui/icons-material/Language';
import { when } from "util/support";
import type { OnboardingPaymentMethodProps } from "./types";

const OnboardingPaymentMethod = ({
    disabled,
    checked,
    onChange,
    imageUrl,
    displayName,
    countriesAvailable,
    slotProps
}: OnboardingPaymentMethodProps) => (
    <Card
        elevation={0}
        {...slotProps?.card}
        sx={{
            borderRadius: 2,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'divider',
            ...slotProps?.card?.sx,
        }}
    >
        <CardContent>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 1
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        alignItems: 'center'
                    }}
                >
                    <Box
                        component='img'
                        src={imageUrl}
                        alt='displayName'
                        sx={{
                            objectFit: 'contain',
                            width: '100%',
                            height: '100%',
                            maxHeight: 64
                        }}
                    />
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            fontSize: 16,
                            mt: 1,
                            textAlign: 'center',
                            color: 'text.primary',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontFamily: 'Public Sans, sans-serif'
                        }}
                    >
                        {displayName}
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        alignContent: 'center'
                    }}
                >
                    <Button
                        sx={{
                            borderRadius: 2
                        }}
                        variant={(
                            when(
                                checked,
                                'contained',
                                'outlined'
                            )
                        )}
                        color='secondary'
                        disabled={disabled}
                        onClick={() => (
                            onChange?.({
                                target: { checked: !checked }
                            } as ChangeEvent<HTMLInputElement>, !checked)
                        )}
                    >
                        Select
                    </Button>
                    <Button
                        variant='outlined'
                        sx={{
                            borderRadius: 2,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            borderColor: 'divider',
                            color: 'text.primary',
                            ':hover': {
                                borderColor: 'divider'
                            }
                        }}
                    >
                        Fees & Pricing
                    </Button>
                </Box>
            </Box>
            <Box
                sx={{
                    mt: 1,
                    pt: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    borderTopColor: 'divider',
                    borderTopStyle: 'solid',
                    borderTopWidth: 1
                }}
            >
                <LanguageIcon
                    sx={{
                        color: 'text.secondary'
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.secondary',
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {countriesAvailable}
                </Box>
            </Box>
        </CardContent>
    </Card>
);

export default OnboardingPaymentMethod;
